import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { DateParamsYearAndMonth } from '@src/types/shared/date_params';
import type { FinishedType } from '@src/types/shared/educational_background';
// Types
import initialState, { type EducationalBackground } from '@src/types/shared/educational_background';
import type { RootState } from '..';

const educationalBackgroundSlice = createSlice({
  name: 'educationalBackground',
  initialState: {
    ...initialState,
    graduationDate: {
      year: '',
      month: '',
    },
  },
  reducers: {
    updateGraduateDate(
      state: EducationalBackground,
      action: PayloadAction<DateParamsYearAndMonth>
    ) {
      // graduationDateが存在しない場合は初期化
      if (!state.graduationDate) {
        state.graduationDate = { year: '', month: '' };
      }
      state.graduationDate = action.payload;
    },
    updateEducationalInstitution(state: EducationalBackground, action: PayloadAction<string>) {
      state.institution = action.payload;
    },
    updateMajor(state: EducationalBackground, action: PayloadAction<string>) {
      state.major = action.payload;
    },
    updateFinishedType(state: EducationalBackground, action: PayloadAction<FinishedType>) {
      state.finishedType = action.payload;
    },
    updateResearchTitle(state: EducationalBackground, action: PayloadAction<string>) {
      state.research.title = action.payload;
    },
    updateResearchDescription(state: EducationalBackground, action: PayloadAction<string>) {
      state.research.description = action.payload;
    },
    updateEducationalBackground(
      state: EducationalBackground,
      action: PayloadAction<EducationalBackground>
    ) {
      // graduationDateが存在しない場合は初期化
      if (!state.graduationDate) {
        state.graduationDate = { year: '', month: '' };
      }

      // 安全にgraduationDateを更新
      if (action.payload.graduationDate) {
        state.graduationDate.month = action.payload.graduationDate.month || '';
        state.graduationDate.year = action.payload.graduationDate.year || '';
      }

      state.finishedType = action.payload.finishedType;
      state.institution = action.payload.institution;
      state.major = action.payload.major;
      state.research.title = action.payload.research.title;
      state.research.description = action.payload.research.description;
    },
  },
});

export const {
  updateGraduateDate,
  updateEducationalInstitution,
  updateMajor,
  updateFinishedType,
  updateResearchTitle,
  updateResearchDescription,
  updateEducationalBackground,
} = educationalBackgroundSlice.actions;

export const selectEducationalBackground = (state: RootState) => state.educationalBackground;

export default educationalBackgroundSlice.reducer;
